module.exports = __webpack_public_path__ + "static/icons/icon-chevron-down-7f46edbb59edb8415c063d584e540779.svg";